h1h1<template>
  <!-- Esperienze lavorative -->
  <div
    :class="
      (widthScreen > 960 ? 'col-8 p-5' : 'col-12 p-2') +
      ` fadeindown
        animation-duration-500 animation-iteration-1
        mx-auto`
    "
  >
    <h1 class="text-center">WORK EXPERIENCE</h1>
    <div class="p-2" v-for="lavoro in lavori" :key="lavoro">
      <div class="grid align-items-center">
        <h2 class="col-6 p-2 text-3xl">{{ lavoro.titolo }}</h2>
        <span class="col-6 p-2 text-xl text-right">{{ lavoro.data }}</span>
        <div class="col-12">
          <span class="p-1 text-xl text-white border-round bg-color-1">{{
            lavoro.azienda
          }}</span>
        </div>
        <div class="col-12 p-2 text-2xl">
          {{ lavoro.descrizione }}
        </div>
      </div>
    </div>
  </div>

  <!-- Esperienza Scolastica-->
  <div
    :class="
      (widthScreen > 960 ? 'col-8 p-5' : 'col-12 p-2') +
      ` fadeindown
        animation-duration-500 animation-iteration-1
        mx-auto`
    "
  >
    <h1 class="text-center">FORMAZIONE</h1>
    <div class="p-2" v-for="dati in formazione" :key="dati">
      <div class="grid align-items-center">
        <h2 class="col-6 p-2 text-3xl">{{ dati.titolo }}</h2>
        <span class="col-6 p-2 text-xl text-right">{{ dati.data }}</span>
        <div class="col-12">
          <span class="p-1 text-xl text-white border-round bg-color-1">{{
            dati.scuola
          }}</span>
        </div>
        <div class="col-12 p-2 text-2xl">
          {{ dati.descrizione }}
        </div>
      </div>
    </div>
  </div>

  <!-- Hobbies -->
  <div
    :class="
      (widthScreen > 960 ? 'col-8 p-5' : 'col-12 p-2') +
      ` fadeindown
        animation-duration-500 animation-iteration-1
        mx-auto`
    "
  >
    <h1 class="text-center">HOBBY</h1>
    <div class="text-center p-2 text-2xl">
      Nel tempo libero mi piace leggere, programmare, guardare Film e Serie TV,
      giocare e progettare videogiochi.
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      lavori: [
        {
          descrizione: `Cybersecurity Front End developer utilizzando React e Carbon Design System.`,
          data: "08/2022 - Presente",
          titolo: "Software Engineer",
          azienda: "AizoOn Technology Consulting",
        },
        {
          descrizione: `Applicazione che permette di salvare, valutare, condividere e commentare film, serie tv e videogiochi. Sviluppata con Ionic, Angular, PrimeNG, Node js e Firebase.`,
          data: "2020 - Presente",
          titolo: "Biblion",
          azienda: "Freelance Developer",
        },
        {
          descrizione: `Sito per il consorzio turistico Valle d'Aosta sviluppato con Angular, PrimeNG, Firebase.`,
          data: "2021 - Presente",
          titolo: "CUVDA",
          azienda: "Freelance Developer",
        },
        {
          descrizione: `Sito web per Rete turismo Valle d'Aosta.`,
          data: "2019 - Presente",
          titolo: "Rete Turismo",
          azienda: "Freelance Developer",
        },
        {
          descrizione: `Sito per info su Navettatrekking.`,
          data: "2018 - 2019",
          titolo: "Italywonderland",
          azienda: "Freelance Developer",
        },
        {
          descrizione: `Programmato con Java, Jsp, Jsf, Sql, Database Oracle.`,
          data: "01/2020 - 02/2020",
          titolo: "Full Stack Developer",
          azienda: "Blue Reply",
        },
      ],
      formazione: [
        {
          descrizione: `Iniziato corso di Intelligenza Artificiale e Data Analytics.`,
          data: "2023 - Presente",
          titolo: "Università",
          scuola: "Università degli studi di Trieste",
        },
        {
          descrizione: `Argomenti trattati: Framework Spring, AJAX, Docker, GitHub, JSP, Servlet, JavaScript, Sviluppo Oracle SQL, Angular, Java, Java Enterprise Edition`,
          data: "05/2022 - 07/2022",
          titolo: "Corso Aziendale",
          scuola: "AizoOn Technology Consulting",
        },
        {
          descrizione: `Argomenti trattati: Database Oracle, Java, Java Enterprise Edition, Html, Css, Javascript, Angular, React.`,
          data: "09/2019 - 12/2019",
          titolo: "Corso Aziendale",
          scuola: "Betacom s.r.l",
        },
        {
          descrizione: `Competenze apprese: C#, Html, Css, Javascript, Php, Sql, Database Relazionali, Reti e Sistemi.`,
          data: "09/2016 - 06/2019",
          titolo: "Scuola Superiore",
          scuola: "IIS Olivetti - Ivrea",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      widthScreen: "getScreenWidth",
    }),
  },
};
</script>
<style scoped lang="scss"></style>
